'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import StatsIcon from '../Images/StatsIcon/index.js';
import { PopoverWhatNewsWrapper, StatsIconGroup, Splitter, WowCVGroup, WowCVLink, WhatNewsHeader, ResponseBottomAction, WhatNewImg, ResponsiveLine, WhatNewsBg, WhatNews, CloseIconWrapper, WhatNewsBody, WhatNewsFooter } from './PopoverWhatNew.css.js';
import CommercialIcon from '../Images/CommercialIcon/index.js';
import CloseIcon from '../Images/CloseIcon/index.js';
import Button from '../Button/index.js';
import { ELanguage } from '../Utils/constants.js';
import translations from './translations.js';
import BottomSheet from '../BottomSheet/index.js';
import { VNW_APPLIED_CANDIDATE, getBannerImageResponsive } from './constants.js';
import { isMobile } from './helper.js';
import { getCookie, setCookie } from '../Utils/cookie.js';
import WowCVIcon from '../Images/WowCVIcon/index.js';
import Tooltip from '../Tooltip/index.js';
import { apiTrackingEvent, apiGetOpenStatus } from './services.js';

var PopoverWhatNews = function (props) {
    var _a = props.displayPosition, displayPosition = _a === void 0 ? 'left' : _a, _b = props.langCode, langCode = _b === void 0 ? ELanguage.VI : _b, _c = props.isApplied, isApplied = _c === void 0 ? false : _c, jobId = props.jobId, _d = props.disabledApply, disabledApply = _d === void 0 ? false : _d, _e = props.msBasePath, msBasePath = _e === void 0 ? 'https://ms.vietnamworks.com' : _e, _f = props.accessToken, accessToken = _f === void 0 ? '' : _f;
    var _g = useState(true), isOpen = _g[0], setOpen = _g[1];
    // Animation
    var _h = useState(false), isTracking = _h[0], setTracking = _h[1];
    var _j = useState(false), isMounted = _j[0], setMounted = _j[1];
    var _k = useState(false), isShowTooltip = _k[0], setShowTooltip = _k[1];
    var _l = useState(false), isShowWowCvTooltip = _l[0], setShowWowCVTooltip = _l[1];
    // Ref
    var closeCountRef = useRef(0);
    // Mobile
    var isInMobile = isMobile();
    var t = function (text) {
        var _a;
        if (langCode === ELanguage.EN) {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var onClick = function () {
        // If element is mounted
        // Then dont setMounted, setOpen for animation
        if (isMounted) {
            setOpen(false);
            return;
        }
        if (isApplied) {
            // redirect to applied page
            window.open("".concat(t('/track-my-competitive-rate/')).concat(jobId), '_blank');
        }
        else {
            setMounted(true);
            setOpen(true);
        }
    };
    var onBottomClick = function () {
        setOpen(false);
        if (!isApplied) {
            // Eval can be harmful in case of dynamic script in it.
            // In this case we only eval initApplyForm (Show apply form in jobDetail page)
            // eslint-disable-next-line no-eval
            window.eval('initApplyModal()');
        }
        else {
            // redirect to applied page
            window.open("".concat(t('/track-my-competitive-rate/')).concat(jobId), '_blank');
        }
    };
    var onWhatNewDesktopAnimationEnd = function () {
        if (isOpen) {
            return;
        }
        setMounted(false);
        setOpen(true);
        setCookie(VNW_APPLIED_CANDIDATE, (closeCountRef.current + 1).toString(), 3);
    };
    var trackingClose = function (type) {
        if (!isTracking) {
            return;
        }
        var postData = {
            numberOfClose: 0,
            numberOfGotIt: 0,
            numberOfApplyNow: 0
        };
        if (type === 'CLOSE') {
            postData.numberOfClose++;
        }
        else if (type === 'APPLY_NOW') {
            postData.numberOfApplyNow++;
        }
        else if (type === 'GOT_IT') {
            postData.numberOfGotIt++;
        }
        apiTrackingEvent({
            baseUrl: msBasePath,
            accessToken: accessToken,
            jobId: jobId,
            postData: postData,
            langCode: langCode === ELanguage.VI ? 'vi' : 'en'
        });
    };
    useEffect(function () {
        var getStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isOpenWithUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiGetOpenStatus({
                            baseUrl: msBasePath,
                            accessToken: accessToken,
                            jobId: jobId,
                            langCode: langCode === ELanguage.VI ? 'vi' : 'en'
                        })];
                    case 1:
                        isOpenWithUser = _a.sent();
                        setMounted(isOpenWithUser);
                        setTracking(isOpenWithUser);
                        return [2 /*return*/];
                }
            });
        }); };
        // Check user logged in or not
        if (accessToken === '') {
            var appliedCandidateCloseCount = 0;
            var appliedCandidateCookie = getCookie(VNW_APPLIED_CANDIDATE);
            if (appliedCandidateCookie !== null) {
                appliedCandidateCloseCount = Number(appliedCandidateCookie);
            }
            // Make sure it is not a number
            if (isNaN(appliedCandidateCloseCount)) {
                appliedCandidateCloseCount = 0;
            }
            closeCountRef.current = appliedCandidateCloseCount;
            if (appliedCandidateCloseCount < 2) {
                setMounted(true);
            }
        }
        else {
            getStatus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var renderBottomAction = function () {
        return isApplied ? (React__default.createElement(Button, { type: 'primary', onClick: onBottomClick }, t('View stats'))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { type: 'default', onClick: function () {
                    setOpen(false);
                    trackingClose('GOT_IT');
                }, style: { marginRight: 8 } }, t('Got It')),
            React__default.createElement(Button, { type: 'primary', onClick: function () {
                    trackingClose('APPLY_NOW');
                    onBottomClick();
                }, disabled: disabledApply }, t('Apply Now'))));
    };
    var renderWhatNew = function () {
        if (isInMobile) {
            var bannerImg_1 = getBannerImageResponsive(langCode);
            return isMounted ? (React__default.createElement(BottomSheet, { onClose: function () {
                    setMounted(false);
                    setCookie(VNW_APPLIED_CANDIDATE, (closeCountRef.current + 1).toString(), 3);
                }, trackingOnClose: function (type) {
                    if (type === 'BACKDROP') {
                        trackingClose('CLOSE');
                    }
                }, header: React__default.createElement(WhatNewsHeader, null,
                    React__default.createElement(CommercialIcon, null),
                    t("What's new")), isOpen: isOpen, footer: React__default.createElement(ResponseBottomAction, null, renderBottomAction()) },
                React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(WhatNewImg, { src: bannerImg_1, alt: t("What's new") }),
                    React__default.createElement(ResponsiveLine, null, t('VietnamWorks calculates your competitive rate based on your application information and compares it with other candidates for this job after you apply.'))))) : null;
        }
        // Desktop
        // Desktop using same image as responsive
        var bannerImg = getBannerImageResponsive(langCode);
        return isMounted ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(WhatNewsBg, { onClick: function () {
                    setOpen(false);
                    trackingClose('CLOSE');
                } }),
            React__default.createElement(WhatNews, { isClose: !isOpen, position: displayPosition, onAnimationEnd: onWhatNewDesktopAnimationEnd },
                React__default.createElement(WhatNewsHeader, null,
                    React__default.createElement(CommercialIcon, null),
                    t("What's new"),
                    React__default.createElement(CloseIconWrapper, { onClick: function () {
                            setOpen(false);
                            trackingClose('CLOSE');
                        } },
                        React__default.createElement(CloseIcon, null))),
                React__default.createElement(WhatNewsBody, null,
                    React__default.createElement(WhatNewImg, { src: bannerImg, alt: t("What's new") }),
                    React__default.createElement("p", null, t('VietnamWorks calculates your competitive rate based on your application information and compares it with other candidates for this job after you apply.'))),
                React__default.createElement(WhatNewsFooter, null, renderBottomAction())))) : null;
    };
    return (React__default.createElement(PopoverWhatNewsWrapper, { "data-test-update": 'updated' },
        React__default.createElement(StatsIconGroup, null,
            React__default.createElement(StatsIcon, { onClick: onClick, onMouseOver: function () { return setShowTooltip(true); }, onMouseLeave: function () { return setShowTooltip(false); } }),
            isShowTooltip && (React__default.createElement(Tooltip, { isShow: isShowTooltip, placement: 'bottom', description: t('Track my competitive rate') })),
            renderWhatNew()),
        React__default.createElement(Splitter, null),
        React__default.createElement(WowCVGroup, null,
            React__default.createElement(WowCVLink, { href: "/wowcv".concat(langCode === ELanguage.EN ? '/en' : ''), onMouseOver: function () {
                    if (isInMobile) {
                        return;
                    }
                    setShowWowCVTooltip(true);
                }, onMouseLeave: function () { return setShowWowCVTooltip(false); } },
                React__default.createElement(WowCVIcon, null)),
            isShowWowCvTooltip && (React__default.createElement(Tooltip, { isShow: isShowWowCvTooltip, placement: 'bottom', description: t('Create CV to apply') })))));
};

export { PopoverWhatNews as default };
//# sourceMappingURL=index.js.map
